import { useEffect, useState } from "react";
import { getJsonViewerDataFromApi, getPayerList } from "../services";
import moment from "moment/moment";
import { toast } from "react-toastify";
import useConnections from "../../pages/Connections/hooks/useConnections";

const FORM_INITIAL_DATA = {
  organizationName: "",
  npi: "",
  firstName: "",
  lastName: "",
  dateOfBirth: null,
  memberId: "",
  taxId: "",
  groupNumber: "",
};

export const useJsonViewerContainer = () => {
  const [jsonData, setJsonData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [formData, setFormData] = useState(FORM_INITIAL_DATA);
  const [tradingPartnerSelected, setTradingPartnerSelected] = useState(null);
  const [payers, setPayers] = useState([]);
  const { clientId } = useConnections();

  useEffect(() => {
    getPayers();
  }, []);

  async function getPayers() {
    await getPayerList().then((response) => {
      if ("success" in response && response.success === false) {
        toast.error(response?.err || "Error retrieving information");
        setPayers([]);
        return;
      }

      setPayers(response);
    });
  }

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const resetForm = () => {
    setFormData(FORM_INITIAL_DATA);
    setErrors([]);
    setTradingPartnerSelected(null);
  };

  async function handleSubmit() {
    await getJsonData();
  }

  const getJsonViewerFilterData = () => {
    const {
      memberId,
      lastName,
      firstName,
      organizationName,
      npi,
      dateOfBirth,
      groupNumber,
      taxId,
    } = formData;

    const request = {
      tradingPartnerServiceId: tradingPartnerSelected.value || null,
      provider: {
        organizationName,
        npi,
        taxId,
      },
      subscriber: {
        firstName,
        lastName,
        dateOfBirth: moment(dateOfBirth, "YYYYMMDD").format("YYYYMMDD"),
        memberId,
        groupNumber,
      },
      clientId,
    };

    if (request.provider.taxId.length <= 0) delete request.provider.taxId;
    if (request.subscriber.groupNumber.length <= 0)
      delete request.subscriber.groupNumber;

    return request;
  };

  const optionalFields = ["taxId", "groupNumber"];

  function isFormComplete() {
    if (!tradingPartnerSelected) return false;

    return Object.entries(formData).every(([key, value]) => {
      if (optionalFields.includes(key)) {
        return true;
      }

      if (value === null || value === undefined) return false;
      return !(typeof value === "string" && value.trim() === "");
    });
  }

  function changeStateLoading(time) {
    setTimeout(() => {
      setIsLoading(false);
    }, time);
  }

  function handleChangeDateOfBirth(newValue) {
    setFormData({ ...formData, dateOfBirth: newValue });
  }

  useEffect(() => {
    if (isFormComplete()) getJsonData();
  }, []);

  async function getJsonData() {
    setIsLoading(true);
    await getJsonViewerDataFromApi(getJsonViewerFilterData())
      .then((response) => {
        console.log(response.errors.length);
        if (response.errors.length > 0) {
          toast.error(response?.message || "Error retrieving information");
          setErrors(response?.errors || []);
          setJsonData(null);
          changeStateLoading(0);
          return;
        }
        setErrors([]);
        setJsonData(response);
        changeStateLoading(500);
      })
      .catch(() => {
        setJsonData(null);
        changeStateLoading(0);
      });
  }

  const handleCloseErrors = () => setErrors([]);

  return {
    handleChange,
    formData,
    resetForm,
    handleSubmit,
    isFormComplete,
    handleChangeDateOfBirth,
    jsonData,
    isLoading,
    errors,
    handleCloseErrors,
    tradingPartnerSelected,
    setTradingPartnerSelected,
    payers,
  };
};
